!function(window) {
/* MAP INIT */

let mapSelector = "leaflet-map";
let map = null;
let markerLayer = null;
let markers = [];
let elevationsData = [];
let elevetionDiff = null;
let totalDistance = null;
let isLoaded = false;
let aGpx = [];
let currLocation;


function setMap(){
	map = new L.map(mapSelector);
	
	L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png', {
		attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',			
		minZoom: 1,
		maxZoom: 17
	}).addTo(map);


	if(checkconnection()){
		$('.message').slideDown().delay(5000).slideUp();
		map.dragging.disable();
	}
	
	markerLayer = new L.layerGroup();
	map.zoomControl.setPosition('bottomleft');
	map.addLayer(markerLayer);
}

function checkconnection() {
	var status = navigator.onLine;
	if (!status) {
		return true;
	}
	return false;
}



function initializeLeafletMap(viewPort, lng) {
	
	initiallize();

	function initiallize(){
		if($('.side-wrapper').attr('data-dataid') != ''){
			getLeafletPath();
			getLeafletMarkers();
		}else{
			getAllLeafletPaths();
		}	
	}
	
	function getAllLeafletPaths(){
		
		/*const ajaxOpts = {
			'func': 'all-paths'	
		}*/

		$.get('/util/ajaxresponse.php?lng='+lng+'&func=all-paths', data => {
			var aLevels = {1:'#129546', 2:'#116eff', 3:'#fdd32a', 4:'#ed2134'} 
		
			var numOfPath = data.length-1;
			var allPaths = 1;
			for (const assoc of data) {
				if(assoc.fileId == null)
					continue;
					
				var gpx = assoc.gpxfile; // URL to your GPX file or the GPX itself
				var wtf = new L.GPX(gpx, {
				async: true,
				marker_options: {
					wptIconUrls: {
						'': '/images/pin-icon-start.png',
						'lago': '/images/pin-icon-end.png'
					},
					startIconUrl: '',
					endIconUrl: '',
					shadowUrl: ''
				},
				polyline_options: {
					color: aLevels[assoc.level],
					opacity: 0.75,
					weight: 9,
					lineCap: 'round',
					footPathHref: assoc.url
				}
				}).on('addpoint', function(e) {
					console.log('Added ' + e.point_type + ' point: ' + e.point_type);
				}).on({
					mouseover: function(e) {
						// _poli je custom napisan v gpx.min.js file-u, da dobi polyline objekt (*predelava);
						var oPolyLine = e.target._poli;
						oPolyLine.setStyle({weight: 18});
					},
					mouseout: function(e) {	
						var oPolyLine = e.target._poli;
						oPolyLine.setStyle({weight: 12});
					}
				}).on('click', function(e) {
					//var pathFile = e.target._gpx.split("/");	
					//markItem(pathFile[pathFile.length-2]);
					window.location.href = e.layer.options.footPathHref;
				}).on('loaded', (e) => {
					var gpx = e.target;	
					var cord = gpx.getBounds();
					aGpx.push([cord._northEast.lat, cord._northEast.lng],[cord._southWest.lat, cord._southWest.lng]);
					
					if(numOfPath == 1){ // da na zadnjem gpx file naredi bounds ker izven on loada aGpx ni dostopen
						var aBounds = L.latLngBounds(aGpx);
						map.fitBounds(aBounds);
					}
					numOfPath--;
					
					getDataFromGpxFile(assoc.fileId, gpx.get_distance(), gpx.get_elevation_max(), gpx.get_elevation_gain());
					
				}).addTo(map);			
			}
		});
	}
	
	function getLeafletPath(){
		
		/*const ajaxOpts = {
			'func': 'associations-path',
			'pathId' : $('.side-wrapper').attr('data-dataid')
		}*/
		var path_id = $('.side-wrapper').attr('data-dataid');
		$.get('/util/ajaxresponse.php?func=associations-path&path_id='+path_id, data => {
			//console.log("#"+data['gpxfile']);
			elevationsData = data['elevations'];
			elevetionDiff = data['elevationDiff'];
			var gpx = data['gpxfile']; // URL to your GPX file or the GPX itself
			
			new L.GPX(gpx, {
			async: true,
			marker_options: {
				wptIconUrls: {
					'': '/images/pin-icon-start.png',
					'lago': '/images/pin-icon-end.png'
				},
				startIconUrl: '',
				endIconUrl: '',
				shadowUrl: ''
			},
			polyline_options: {
				color: '#116eff',
				opacity: 0.75,
				weight: 9,
				lineCap: 'round'
			}
			}).on('addpoint', function(e) {
				console.log('Added ' + e.point_type + ' point: ' + e.point_type);
			}).on('loaded', function (e) {
				var gpx = e.target;
				totalDistance = gpx.get_distance();

				drawElevationProfile();
				getDataFromGpxFile(data['fileId'], gpx.get_distance(), gpx.get_elevation_max(), gpx.get_elevation_gain());
				
				map.fitBounds(gpx.getBounds());
			}).addTo(map);
			
		});
	}

	/** shows markers for path */
	function getLeafletMarkers() {
		let last = null;

		/*const ajaxOpts = {
			'func': 'associations-markers',
			'pathId' : $('.side-wrapper').attr('data-dataid')
		}*/
		var path_id = $('.side-wrapper').attr('data-dataid');
		$.get('/util/ajaxresponse.php?func=associations-markers&path_id='+path_id, data => {
			// clear previous just in case
			markerLayer.clearLayers();
			var aIcons = {'start':'/images/backgrounds/start.svg', 'accommodation':'/images/backgrounds/house.svg', 'food':'/images/backgrounds/food.svg', 'heritage':'/images/backgrounds/heritage.svg', 'nature':'/images/backgrounds/tree.svg'}
			
			if (data.length) {
				const bounds = [];
	
				for (const assoc of data) {
					
					const leafletIcon = new L.icon({
						iconUrl: (assoc.category)? aIcons[assoc.category] : '/images/backgrounds/pin.svg' ,
						iconSize: [32, 32],
						iconAnchor: [16, 16]
					})
	
					bounds.push([assoc.latitude, assoc.longitude]);	
					var marker = L.marker([assoc.latitude, assoc.longitude], {
						icon: leafletIcon,
						id:assoc.id
					});
					
					var img = (assoc.slika)? '<div style="background-image:url('+assoc.slika+'); background-repeat:no-repeat; background-size:cover; background-position:center; width:100%; height:120px; margin-bottom:15px;"></div>' : '';
					var dist = (assoc.distance)? assoc.distance : '/ ';
					var razdalja = (lng == 'slo')? 'Razdalja' : 'Distance';
					marker.bindPopup('<h2>'+assoc.title+'</h2><br>'+img+'<span style="margin-left:12px; font-size:0.8571rem; font-weight: 600;">'+razdalja+':<span style="font-weight: 400; color:#868686;"> '+dist+'km</span></span><p style="margin-left: 30px; text-align: left;">'+assoc.content+'</p>');
					
					marker.on({
						mouseover: function() {
							if (assoc.id && assoc.id != last) {
								markItem(assoc.id);				
							}
						},
						mouseout: function() {	
							reserMarkedItem();		
						}
					});
		
					markers.push(marker);
					markerLayer.addLayer(marker);
				}
				
				//map.fitBounds(bounds);
			}
			getLocation();

		});
	}

	/** it change map overlayer by calling different maps */
	function changeMapLayer(){
		$('.maplayer').on('click', function(){
			markers = []; //počisti markerje ki so bili že dodani na mapo da ko se preklopi na drugo mapo ne ostanejo notri 
			
			var layerType = $(this).attr('data-layer');

			// pobiše vse dodane mape
			map.eachLayer(function (layer) {
				map.removeLayer(layer);
			});

			if(layerType == 'terrain'){

				L.tileLayer('http://{s}.google.com/vt/lyrs=p&x={x}&y={y}&z={z}',{
					maxZoom: 17,
					subdomains:['mt0','mt1','mt2','mt3']
				}).addTo(map);

			}else if(layerType == 'satelite'){

				L.tileLayer('http://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}',{
					maxZoom: 17,
					subdomains:['mt0','mt1','mt2','mt3']
				}).addTo(map);

			}else{

				L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png', {
					attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
					minZoom: 1,
					maxZoom: 17
				}).addTo(map);

			}	

			initiallize();
			map.addLayer(markerLayer);
		});
	}

	/** on marker hover mark item in side menu */
	function markItem(id){
		$('.path-wrapper').css({"border": "3px solid #fff"});
		$(`[data-path-id=${id}]`).css({"border": "3px solid #fdd32a"});
	}
	function reserMarkedItem(){
		$('.path-wrapper').css({"border": "3px solid #fff"});
	}

	/** it open marker popup by clicking path point in sidebar */
	function openFootPointPopup(){
		$('.path-wrapper').on('click', function(){
			var id = $(this).attr('data-path-id');
			for(var i in markers){
				if(markers[i].options.id == id){
					markers[i].openPopup();
					break;
				}
			}
			$('.side-wrapper').removeClass('open-side-menu');
			$('.burger-menu > img').toggleClass('lines cross');	
		});
	}

	//function that gets the location and returns it
	function getLocation() {
		if(navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(showPosition);
		}else{
			console.log("ni dovoljenj");
		}
	}
	//function that retrieves the position
	function showPosition(position) {
		var location = {
			longitude: position.coords.longitude,
			latitude: position.coords.latitude
		}

		const leafletIcon = new L.icon({
			iconUrl: '/images/backgrounds/mylocation.svg',
			iconSize: [40, 40],
			iconAnchor: [20, 20]
		})
	
		var marker = L.marker([location.latitude, location.longitude], {
			icon: leafletIcon
		});
	
		markerLayer.addLayer(marker);
	}
	//request for location
	

	function getDataFromGpxFile(selector, distance, maxElevation, elevationGain){
		setDistanceFromFile(selector, distance);
		setMaxElevationFromFile(selector, maxElevation);
		setElevationDiffFromFile(selector, elevationGain);
		setTimeFromFile(selector, distance, elevationGain);
	}

	function setDistanceFromFile(selector, distance){
		var selectoName = $(`[data-path-id = ${selector}]`).find('#dist');
		if($(selectoName).text() == 'km'){
			$(selectoName).html(Number(Math.round((distance/1000) + 'e2', 1)+'e-2')+'km');
		}
	}

	function setMaxElevationFromFile(selector, maxElevation){
		var selectoName = $(`[data-path-id = ${selector}]`).find('#max-alt');
		if($(selectoName).text() == 'm'){
			$(selectoName).html(Math.round(maxElevation)+'m');
		}
	}

	function setElevationDiffFromFile(selector, elevationGain) {
		var selectoName = $(`[data-path-id = ${selector}]`).find('#diff');
		if($(selectoName).text() == 'm'){
			$(selectoName).html(Math.round(elevationGain)+'m');
		}
	}

	function setTimeFromFile(selector, distance, elevationGain) {
		var selectoName = $(`[data-path-id = ${selector}]`).find('#time');
	
		if($(selectoName).text() == 'h'){
			var koeficient = 2.2;
			
			if(elevationGain <= 600 && elevationGain >= 350){
				koeficient = 2.9;
			}else if(elevationGain <= 349 && elevationGain >= 200){
				koeficient = 3.15;
			}else if(elevationGain <= 199 && elevationGain >= 150){
				koeficient = 4;
			}else if(elevationGain <= 149 && elevationGain >= 0){
				koeficient = 5.5;
			}

			var time = Number(Math.round((distance/1000) / koeficient + 'e2', 1)+'e-2'); 
			var p = Math.floor(time);
			var t = time - Math.floor(time);

			if(t >= 0.3 && t <= 0.7){
				p = Math.floor(time) + 0.5;
			}else if(t>0.7){
				p = Math.ceil(time);
			}
			
			$(selectoName).html(p+'h');
		}
	}

	function setDistancexAxes(){
		var labels = [];
		var dist = (totalDistance/1000) / elevationsData.length;
		var st = 0;
		for(var i=0; i<elevationsData.length; i++){

			if(st == 4){
				labels[i] = `${Number(Math.round(dist*i + 'e1', 1)+'e-1')}km`;	
				st=0;	
			}else{
				labels[i] = '';
			}
			st++;		
		}

		return labels; 
	}

	/** za mobile skrije x os */
	function hideXaxes(){
		var options = {}
		if(viewPort < 768){
			options = {
				xAxes: [{
					ticks: { // skrije x os 
						display: false 
					}	
				}] // ce zelimo da se graf zacne z 0
				/*yAxes: [{
					ticks: {
						beginAtZero:true
					}
				}]*/
			}
		}
	
		return options;
	}

	/** shows elevation profile on graph */
	function drawElevationProfile(){
		
		if($('.elevation-wrapper').length && !isLoaded){
			var ctx = document.getElementById("elevationProfile").getContext("2d");
			var gradient = ctx.createLinearGradient(0, 0, 0, 400);
			gradient.addColorStop(0, 'rgba(17, 110, 255, 1)');   
			gradient.addColorStop(1, 'rgba(255, 255, 255, 0)');
			//console.log(elevationsData);
			var l = setDistancexAxes();
			var myChart = new Chart(ctx, {
				type: 'line',
				data: {
					labels: l,
					datasets: [{	
						data: elevationsData,
						defaultFontColor: 'red',
						backgroundColor: gradient,
						borderColor: "#116eff",
						pointBackgroundColor: "#fff",
						pointBorderColor: "#116eff",
						lineTension: 0,
						pointHoverBackgroundColor: "#fff",
						pointHoverBorderColor: "#fdd32a",
						borderWidth: 2		
					}]
				},
				options: {
					legend: {
						display: false,
					},
					tooltips: {

						callbacks: {
							title: function(tooltipItem, data) {
							  return ;
							},
							label: function(tooltipItem, data) {
							  return data['datasets'][0]['data'][tooltipItem['index']]+'m';
							}
							
						},
						backgroundColor: '#000',
						borderColor:'#000',
						titleFontSize: 16,
						titleFontColor: '#0066ff',
						bodyFontColor: '#fff',
						bodyFontSize: 16,
						displayColors: false
					},
					maintainAspectRatio: false,
					scales: hideXaxes(),
					elements: { // skrije krogce
						point: { 
						  radius: 0,
						  hitRadius: 10, 
						  hoverRadius: 5,
						} 
					  } 
				}
			});
			isLoaded = true;
		}	
	}
	setMap();
	changeMapLayer();
	openFootPointPopup();
}

module.exports = {map : initializeLeafletMap};
window.mapSelector = mapSelector;
window.map = map;
window.markerLayer = markerLayer;
window.markers = markers;
window.elevationsData = elevationsData;
window.elevetionDiff = elevetionDiff;
window.totalDistance = totalDistance;
window.isLoaded = isLoaded;
window.aGpx = aGpx;
window.currLocation = currLocation;
window.setMap = setMap;
window.checkconnection = checkconnection;
window.initializeLeafletMap = initializeLeafletMap;
}.call(window, window);